import { FC, useMemo } from 'react';
import styled from 'styled-components';
import { ExpandableLongText } from '../../common/components';
import { ValidationMessage } from '../../common/utils/ValidationMessagesMap';

interface ValidationRuleErrorDetailsProps {
  index: number;
  messages: ValidationMessage[];
}

export const ValidationRuleErrorDetails: FC<
  ValidationRuleErrorDetailsProps
> = ({ index, messages }) => {
  const details = useMemo(() => {
    const uniqueDetails = Array.from(
      new Set(
        messages
          .map(({ details }) => details?.trim())
          .filter((item): item is string => Boolean(item)),
      ),
    );

    return uniqueDetails.join('\n\n');
  }, [messages]);

  if (!details) return null;

  return (
    <ErrorDetailsWrapper>
      <ExpandableLongText
        id={`validation-rule-check-details-${index}`}
        rows={5}
      >
        {details}
      </ExpandableLongText>
    </ErrorDetailsWrapper>
  );
};

const ErrorDetailsWrapper = styled.div`
  margin-top: 8px;
  font-family: monospace;
  white-space: pre-wrap;

  .ant-btn-link {
    display: block;
  }
`;
